document.addEventListener("DOMContentLoaded", function () {
  console.log("Settlio AI is loaded!");

  function sendToAI(formData) {
    fetch("https://your-settlio-api.com/relocation", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer YOUR-SETTLIO-API-KEY",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        document.getElementById("ai-results").innerHTML =
          data.recommendation || "No recommendations found.";
      })
      .catch((error) => {
        console.error("Error:", error);
        document.getElementById("ai-results").innerHTML =
          "Error connecting to AI.";
      });
  }

  let form = document.getElementById("ai-relocation-form");
  if (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      let formData = new FormData(form);
      sendToAI(Object.fromEntries(formData));
    });
  }
});
